// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'planilhas.page.title': 'Planilhas',
    'planilhas.page.search': 'Buscar planilhas...',
    'planilhas.page.filter.situacao': 'Situação',
    'planilhas.page.filter.todas': 'Todas',
    'planilhas.page.tipo.colheita': 'Colheita',
    'planilhas.page.tipo.despendoamento': 'Despendoamento',
    'planilhas.page.tipo.aluguel': 'Aluguel',
    'planilhas.page.col.contrato': 'Contrato',
    'planilhas.page.col.planilha': 'Planilha',
    'planilhas.page.col.cliente': 'Cliente',
    'planilhas.page.col.cooperante': 'Cooperante',
    'planilhas.page.col.pivot': 'Pivô',
    'planilhas.page.col.safra': 'Safra',
    'planilhas.page.col.periodo': 'Período',
    'planilhas.page.col.origem': 'Origem',
    'planilhas.page.col.situacao': 'Situação',
    'planilhas.page.periodo.realizado': 'Realizado',
    'planilhas.page.periodo.previsto': 'Previsto',
    'planilhas.page.semStatus': 'Sem situação',
    'planilhas.page.empty': 'Nenhuma planilha neste recorte.',
    'planilhas.page.emptySearch': 'Nenhuma planilha para "{{query}}".',
    'planilhas.page.resumo.sincronizacao': 'Última sincronização',
    'planilhas.page.resumo.total': 'Total',
    'planilhas.page.resumo.comMedicao': 'Com medição',
    'planilhas.page.resumo.semSincronizacao': 'Ainda não sincronizado',
    'planilhas.page.detalhe.eyebrow': 'Planilha de campo do Protheus',
    'planilhas.page.detalhe.contrato': 'Contrato',
    'planilhas.page.detalhe.tipo': 'Tipo de serviço',
    'planilhas.page.detalhe.planilha': 'Planilha',
    'planilhas.page.detalhe.subcontrato': 'Subcontrato',
    'planilhas.page.detalhe.filial': 'Filial',
    'planilhas.page.detalhe.pivot': 'Pivô',
    'planilhas.page.detalhe.safra': 'Safra',
    'planilhas.page.detalhe.ano': 'Ano',
    'planilhas.page.detalhe.status': 'Situação',
    'planilhas.page.detalhe.nomeCliente': 'Cliente, razão social',
    'planilhas.page.detalhe.fantasiaCliente': 'Cliente, nome fantasia',
    'planilhas.page.detalhe.nomeCooperante': 'Cooperante, razão social',
    'planilhas.page.detalhe.cooperanteHint': 'Produtor onde o serviço acontece. Não é o cliente',
    'planilhas.page.detalhe.fantasiaCooperante': 'Cooperante, nome fantasia',
    'planilhas.page.detalhe.inicioPrevisto': 'Início previsto',
    'planilhas.page.detalhe.finalPrevisto': 'Final previsto',
    'planilhas.page.detalhe.dataInicio': 'Início realizado',
    'planilhas.page.detalhe.dataFinal': 'Final realizado',
    'planilhas.page.detalhe.qtdContratado': 'Quantidade contratada',
    'planilhas.page.detalhe.qtdRealizado': 'Quantidade realizada',
    'planilhas.page.detalhe.semMedicao': 'A origem ainda não informa a medição',
    'planilhas.page.detalhe.dataLancamento': 'Lançamento',
    'planilhas.page.detalhe.sincronizado': 'Sincronizado em',
    'planilhas.page.detalhe.fechar': 'Fechar',
  },
  en: {
    'planilhas.page.title': 'Field sheets',
    'planilhas.page.search': 'Search field sheets...',
    'planilhas.page.filter.situacao': 'Status',
    'planilhas.page.filter.todas': 'All',
    'planilhas.page.tipo.colheita': 'Harvesting',
    'planilhas.page.tipo.despendoamento': 'Detasseling',
    'planilhas.page.tipo.aluguel': 'Rental',
    'planilhas.page.col.contrato': 'Contract',
    'planilhas.page.col.planilha': 'Sheet',
    'planilhas.page.col.cliente': 'Client',
    'planilhas.page.col.cooperante': 'Grower',
    'planilhas.page.col.pivot': 'Pivot',
    'planilhas.page.col.safra': 'Season',
    'planilhas.page.col.periodo': 'Period',
    'planilhas.page.col.origem': 'Source',
    'planilhas.page.col.situacao': 'Status',
    'planilhas.page.periodo.realizado': 'Actual',
    'planilhas.page.periodo.previsto': 'Planned',
    'planilhas.page.semStatus': 'No status',
    'planilhas.page.empty': 'No field sheet in this view.',
    'planilhas.page.emptySearch': 'No field sheet for "{{query}}".',
    'planilhas.page.resumo.sincronizacao': 'Last sync',
    'planilhas.page.resumo.total': 'Total',
    'planilhas.page.resumo.comMedicao': 'With measurement',
    'planilhas.page.resumo.semSincronizacao': 'Not synced yet',
    'planilhas.page.detalhe.eyebrow': 'Protheus field sheet',
    'planilhas.page.detalhe.contrato': 'Contract',
    'planilhas.page.detalhe.tipo': 'Service type',
    'planilhas.page.detalhe.planilha': 'Sheet',
    'planilhas.page.detalhe.subcontrato': 'Subcontract',
    'planilhas.page.detalhe.filial': 'Branch',
    'planilhas.page.detalhe.pivot': 'Pivot',
    'planilhas.page.detalhe.safra': 'Season',
    'planilhas.page.detalhe.ano': 'Year',
    'planilhas.page.detalhe.status': 'Status',
    'planilhas.page.detalhe.nomeCliente': 'Client, legal name',
    'planilhas.page.detalhe.fantasiaCliente': 'Client, trade name',
    'planilhas.page.detalhe.nomeCooperante': 'Grower, legal name',
    'planilhas.page.detalhe.cooperanteHint': 'Producer where the service happens. Not the client',
    'planilhas.page.detalhe.fantasiaCooperante': 'Grower, trade name',
    'planilhas.page.detalhe.inicioPrevisto': 'Planned start',
    'planilhas.page.detalhe.finalPrevisto': 'Planned end',
    'planilhas.page.detalhe.dataInicio': 'Actual start',
    'planilhas.page.detalhe.dataFinal': 'Actual end',
    'planilhas.page.detalhe.qtdContratado': 'Contracted quantity',
    'planilhas.page.detalhe.qtdRealizado': 'Delivered quantity',
    'planilhas.page.detalhe.semMedicao': 'The source does not send measurement yet',
    'planilhas.page.detalhe.dataLancamento': 'Entered on',
    'planilhas.page.detalhe.sincronizado': 'Synced at',
    'planilhas.page.detalhe.fechar': 'Close',
  },
  es: {
    'planilhas.page.title': 'Planillas',
    'planilhas.page.search': 'Buscar planillas...',
    'planilhas.page.filter.situacao': 'Situación',
    'planilhas.page.filter.todas': 'Todas',
    'planilhas.page.tipo.colheita': 'Cosecha',
    'planilhas.page.tipo.despendoamento': 'Desespigado',
    'planilhas.page.tipo.aluguel': 'Alquiler',
    'planilhas.page.col.contrato': 'Contrato',
    'planilhas.page.col.planilha': 'Planilla',
    'planilhas.page.col.cliente': 'Cliente',
    'planilhas.page.col.cooperante': 'Cooperante',
    'planilhas.page.col.pivot': 'Pivote',
    'planilhas.page.col.safra': 'Zafra',
    'planilhas.page.col.periodo': 'Período',
    'planilhas.page.col.origem': 'Origen',
    'planilhas.page.col.situacao': 'Situación',
    'planilhas.page.periodo.realizado': 'Realizado',
    'planilhas.page.periodo.previsto': 'Previsto',
    'planilhas.page.semStatus': 'Sin situación',
    'planilhas.page.empty': 'Ninguna planilla en este recorte.',
    'planilhas.page.emptySearch': 'Ninguna planilla para "{{query}}".',
    'planilhas.page.resumo.sincronizacao': 'Última sincronización',
    'planilhas.page.resumo.total': 'Total',
    'planilhas.page.resumo.comMedicao': 'Con medición',
    'planilhas.page.resumo.semSincronizacao': 'Aún no sincronizado',
    'planilhas.page.detalhe.eyebrow': 'Planilla de campo de Protheus',
    'planilhas.page.detalhe.contrato': 'Contrato',
    'planilhas.page.detalhe.tipo': 'Tipo de servicio',
    'planilhas.page.detalhe.planilha': 'Planilla',
    'planilhas.page.detalhe.subcontrato': 'Subcontrato',
    'planilhas.page.detalhe.filial': 'Sucursal',
    'planilhas.page.detalhe.pivot': 'Pivote',
    'planilhas.page.detalhe.safra': 'Zafra',
    'planilhas.page.detalhe.ano': 'Año',
    'planilhas.page.detalhe.status': 'Situación',
    'planilhas.page.detalhe.nomeCliente': 'Cliente, razón social',
    'planilhas.page.detalhe.fantasiaCliente': 'Cliente, nombre comercial',
    'planilhas.page.detalhe.nomeCooperante': 'Cooperante, razón social',
    'planilhas.page.detalhe.cooperanteHint': 'Productor donde ocurre el servicio. No es el cliente',
    'planilhas.page.detalhe.fantasiaCooperante': 'Cooperante, nombre comercial',
    'planilhas.page.detalhe.inicioPrevisto': 'Inicio previsto',
    'planilhas.page.detalhe.finalPrevisto': 'Final previsto',
    'planilhas.page.detalhe.dataInicio': 'Inicio realizado',
    'planilhas.page.detalhe.dataFinal': 'Final realizado',
    'planilhas.page.detalhe.qtdContratado': 'Cantidad contratada',
    'planilhas.page.detalhe.qtdRealizado': 'Cantidad realizada',
    'planilhas.page.detalhe.semMedicao': 'El origen aún no informa la medición',
    'planilhas.page.detalhe.dataLancamento': 'Lanzamiento',
    'planilhas.page.detalhe.sincronizado': 'Sincronizado el',
    'planilhas.page.detalhe.fechar': 'Cerrar',
  },
}
